<!-- ========================================================= -->
<!-- Start HSR Banner Section -->
<!-- ========================================================= -->

<div class="ecb-web-public-page">

    <!-- Start HSR Banner Section -->
    <section class="ecb-web-hsr-banner-section">

        <!-- Start HSR Banner Overlay -->
        <div class="ecb-web-hsr-banner-overlay"></div>
        <!-- End HSR Banner Overlay -->

        <div class="container ecb-web-hsr-banner-container">

            <div class="row align-items-center">

                <!-- Start HSR Banner Content -->
                <div class="col-12 col-lg-6">

                    <div class="ecb-web-hsr-banner-content">



                        <span class="ecb-web-hsr-banner-label">

                        </span>
                        <span class="pill"> WORK SAFE APPROVED</span>


                        <h1>
                            HSR Initial OHS Training Course
                        </h1>


                        <div class="ecb-web-hsr-banner-line"></div>


                        <p>
                            This 5-day WorkSafe-approved OHS training course aims at providing Health and Safety
                            Representatives (HSRs) the skills, knowledge and confidence to represent their designated
                            work group and help make their workplace safer.
                        </p>

                    </div>

                </div>
                <!-- End HSR Banner Content -->
                <div class="col-12 col-lg-6">

                    <div class="ecb-web-hsr-banner-image-wrapper">

                        <img style="width: 500px;" src="/assets/images/Worksafetran.png" alt="HSR Training"
                            class="ecb-web-hsr-banner-image" />

                    </div>

                </div>
            </div>

        </div>

    </section>
    <!-- End HSR Banner Section -->

</div>


<!-- ========================================================= -->
<!-- End HSR Banner Section -->
<!-- ========================================================= -->



<!-- ========================================================= -->
<!-- Start HSR Introduction Section -->
<!-- ========================================================= -->
<section class="ecb-web-hsr-introduction-section">

    <div class="container">

        <div class="row g-4 align-items-start">

            <div class="col-12 col-lg-6">

                <div class="ecb-web-hsr-introduction-content">

                    <span class="ecb-web-hsr-section-label">
                        WORK SAFE APPROVED
                    </span>

                    <h2>
                        HSR Initial OHS Training Course
                    </h2>

                    <div class="ecb-web-hsr-section-line"></div>

                    <p>This 5-day WorkSafe-approved OHS training course aims at providing Health and Safety
                        Representatives (HSRs) the skills, knowledge, and confidence to represent their designated work
                        group by providing workplace health and safety training to help make their workplace safer.</p>
                    <p>The training aims to give HSRs the basic knowledge and skills to exercise their powers and rights
                        effectively as an HSR.</p>
                    <p>Under section 67 of the Victoria OHS Act 2004 an employer, if requested, must allow an elected
                        HSR and elected Deputy HSR to attend a WorkSafe approved HSR OHS Training Course on paid time
                        off work, pay the cost of the course and any other associated costs. Section 67 also allows HSRs
                        to choose the approved training course they attend in consultation with their employer.</p>
                    <p>Although HSRs are the primary audience, managers and supervisors or anyone with an interest in
                        workplace health and safety training may also benefit by attending this course.</p>

                </div>

            </div>


            <div class="col-12 col-lg-6">

                <div class="ecb-web-hsr-info-card">
                    <div class="row">

                        <div class="col-12 col-lg-6 ecb-web-hsr-section-divider">


                            <div class="ecb-web-hsr-course-dates-card">

                                <div class="ecb-web-hsr-course-dates-header">
                                    <div class="ecb-web-hsr-info-card-icon">
                                        <i class="bi bi-calendar3"></i>
                                    </div>
                                    <div>
                                        <h3>Course Dates</h3>
                                        <p>This course will operate over the following 5 days.</p>
                                    </div>
                                </div>

                                <div class="ecb-web-hsr-course-dates-table-wrapper">
                                    <table class="ecb-web-hsr-course-dates-table">
                                        <tbody>
                                            <tr *ngFor="let entry of hsrCourseDates; trackBy: trackHsrDate"
                                                [class.hsr-date-initial]="entry.type === 'initial'"
                                                [class.hsr-date-refresher]="entry.type === 'refresher'"
                                                [title]="entry.courseLabel">
                                                <td>{{ entry.day }}</td>
                                                <td>{{ entry.date }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p class="hsr-dates-feedback" *ngIf="loadingHsrDates">Loading course dates...</p>
                                    <p class="hsr-dates-feedback" *ngIf="hsrDateError">{{ hsrDateError }}</p>
                                    <p class="hsr-dates-feedback"
                                        *ngIf="!loadingHsrDates && !hsrDateError && hsrCourseDates.length === 0">
                                        No course dates available.
                                    </p>
                                </div>

                                <div class="ecb-web-hsr-course-dates-refresher">

                                    <div class="ecb-web-hsr-course-dates-refresher-content"
                                        *ngIf="nextRefresherDate as refresher">

                                        <span>Refresher Course</span>
                                        <strong>{{ refresher.day }} {{ refresher.date }}</strong>

                                    </div>

                                    <div class="ecb-web-hsr-course-dates-refresher-content"
                                        *ngIf="!nextRefresherDate as refresher">

                                        <span>Refresher Course</span>
                                        <strong style="color:rgb(197, 197, 197)"> --/--</strong>

                                    </div>
                                    <div class="ecb-web-hsr-course-dates-refresher-price">

                                        <ng-container *ngIf="RefresherCoursePrice > 0; else enquiryButton">

                                            <small>Fee</small>

                                            <strong>
                                                {{ RefresherCoursePrice | currency:'AUD':'symbol':'1.2-2' }}
                                            </strong>

                                        </ng-container>

                                        <ng-template #enquiryButton>
                                            <a routerLink="/contact-us" class="ecb-web-hsr-refresher-enquiry-btn">
                                                Enquire Now
                                            </a>
                                        </ng-template>

                                    </div>

                                </div>



                            </div>
                        </div>




                        <div class="col-12 col-lg-6">
                            <div class="ecb-web-hsr-info-card-header">

                                <div class="ecb-web-hsr-info-card-icon">
                                    <i class="bi bi-geo-alt"></i>
                                </div>

                                <div>
                                    <h3>Fees & Location</h3>
                                    <div class="ecb-web-hsr-info-card-line"></div>
                                </div>

                            </div>


                            <div class="ecb-web-hsr-info-card-section">

                                <div class="ecb-web-hsr-info-card-row">

                                    <div class="ecb-web-hsr-info-card-symbol">
                                        <i class="bi bi-currency-dollar"></i>
                                    </div>

                                    <div class="ecb-web-hsr-info-card-content">
                                        <small>Course Fees</small>
                                        <h4>{{ InitialOccupationalPrice | currency:'AUD':'symbol':'1.2-2' }}</h4>
                                    </div>

                                </div>

                            </div>


                            <div class="ecb-web-hsr-info-card-divider"></div>


                            <div class="ecb-web-hsr-info-card-section">

                                <div class="ecb-web-hsr-info-card-row">

                                    <div class="ecb-web-hsr-info-card-symbol">
                                        <i class="bi bi-geo-alt-fill"></i>
                                    </div>

                                    <div class="ecb-web-hsr-info-card-content">
                                        <small>Locations</small>

                                        <div class="ecb-web-hsr-info-card-location">

                                            <span>ECB - ALTONA NORTH VIC</span>
                                        </div>
                                    </div>

                                </div>

                            </div>


                            <a routerLink="/contact-us" href="/contact-us" class="ecb-web-hsr-info-card-button">
                                <span>Enquire now</span>
                                <i class="bi bi-arrow-right"></i>
                            </a>


                            <div class="ecb-web-hsr-info-card-contact">

                                <div class="ecb-web-hsr-info-card-contact-icon">
                                    <i class="bi bi-telephone-fill"></i>
                                </div>

                                <div class="ecb-web-hsr-info-card-contact-content">
                                    <p>Contact ECB Training for fees and upcoming course locations.</p>

                                    <a href="tel:1300322486">
                                        1300 322 486
                                    </a>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>

</section>
<!-- ========================================================= -->
<!-- End HSR Introduction Section -->
<!-- ========================================================= -->



<!-- ========================================================= -->
<!-- Start Learning Objectives Section -->
<!-- ========================================================= -->

<section class="ecb-web-hsr-objectives-section">

    <div class="container">

        <div class="row align-items-stretch g-0">

            <!-- Start Learning Objectives Image -->
            <div class="col-12 col-lg-5">

                <div class="ecb-web-hsr-objectives-image">

                    <img src="/assets/images/categories/default-category.jpg"
                        alt="Health and safety representative training" />

                </div>

            </div>
            <!-- End Learning Objectives Image -->


            <!-- Start Learning Objectives Content -->
            <div class="col-12 col-lg-7">

                <div class="ecb-web-hsr-objectives-content">

                    <!-- Heading -->
                    <h2>

                        LEARNING <span>OBJECTIVES</span>

                    </h2>


                    <!-- Description -->
                    <div class="ecb-web-hsr-objectives-description">

                        <p>To exercise powers and rights as Health and Safety Representative effectively, it is
                            essential that you receive training. This training course aims to provide you with the
                            skills, knowledge and confidence to represent your designated work group and make sure your
                            workplace safer.</p>
                        <p>This course is also suitable for managers, supervisors, health and safety committee members
                            and anyone with an interest in health and safety.</p>

                    </div>


                    <!-- Subtitle -->
                    <h3>
                        This OHS representative training course will help you develop the skills when:
                    </h3>


                    <!-- Objectives -->
                    <ul class="ecb-web-hsr-objectives-list">

                        <li><i class="bi bi-check-circle-fill"></i><span>Interpret the occupational health and safety
                                legislative framework</span></li>
                        <li><i class="bi bi-check-circle-fill"></i><span>Identify key parties and their legislative
                                obligations and duties</span></li>
                        <li><i class="bi bi-check-circle-fill"></i><span>Establish representation in the
                                workplace</span></li>
                        <li><i class="bi bi-check-circle-fill"></i><span>Participate in consultation and issue
                                resolution</span></li>
                        <li><i class="bi bi-check-circle-fill"></i><span>Represent designated work groups in any OHS
                                risk management process undertaken by the appropriate duty holder/s</span></li>
                        <li><i class="bi bi-check-circle-fill"></i><span>Issue a Provisional Improvement Notice (PIN)
                                and directing the cessation of work</span></li>

                    </ul>

                </div>

            </div>
            <!-- End Learning Objectives Content -->

        </div>

    </div>

</section>

<!-- ========================================================= -->
<!-- End Learning Objectives Section -->
<!-- ========================================================= -->



<!-- ========================================================= -->
<!-- Start Course Information Section -->
<!-- ========================================================= -->

<section class="ecb-web-hsr-course-information-section">

    <div class="container">

        <div class="ecb-web-hsr-course-information-wrapper">

            <div class="row g-4">

                <!-- ================================================= -->
                <!-- Left Column -->
                <!-- ================================================= -->

                <div class="col-12 col-lg-4">

                    <div class="ecb-web-hsr-information-block">
                        <h3>Course Duration</h3>
                        <p>The course duration is seven hours per day and 35 hours over five days (excluding breaks).
                        </p>
                    </div>
                    <div class="ecb-web-hsr-information-block">
                        <h3>Make Up Sessions</h3>
                        <p>If you are unable to attend any of the sessions, MAKE UP sessions must be completed within 6
                            months of commencement of the date of the first workshop.</p>
                        <p>Please email the ECB Training Course Coordinator at admin&#64;ecbtraining.com.au.</p>
                        <a routerLink="/contact-us" class="ecb-web-hsr-information-link">Enquire now <i
                                class="bi bi-arrow-right"></i></a>
                    </div>

                </div>


                <!-- ================================================= -->
                <!-- Middle Column -->
                <!-- ================================================= -->

                <div class="col-12 col-lg-4">

                    <div class="ecb-web-hsr-information-block">

                        <h3>Course Fees</h3>


                        <p>It is ECB Training’s policy that the course fee will be all-inclusive.</p>
                        <p>Students will not be “surprised” by unexpected requirements, fees or expenses.</p>
                        <p>Course location and venue details will be confirmed by ECB Training as part of the booking
                            process.</p>




                        <p>
                            Face to face (Morning tea & Lunch will be provided)
                        </p>

                    </div>

                </div>


                <!-- ================================================= -->
                <!-- Right Column -->
                <!-- ================================================= -->

                <div class="col-12 col-lg-4">

                    <div class="ecb-web-hsr-information-block">

                        <h3>Student Support</h3>


                        <p>ECB Training recognises that not all people learn in the same manner, and that with an amount
                            of “reasonable adjustment” students who may not learn best with traditional learning will
                            still achieve good results.</p>
                        <p>Reasonable adjustment may be offered to students with a disability or learning difficulty
                            according to the nature of the disability or difficulty.</p>
                        <p>Reasonable adjustments may include the use of adaptive technology, educational support.</p>
                        <p>Should you need support in undertaking this training because of learning difficulties or a
                            disability, please contact the ECB Training Course Coordinator at
                            admin&#64;ecbtraining.com.au.</p>

                        <a routerLink="/contact-us" class="ecb-web-hsr-information-link" href="/contact-us">Enquire now
                            <i class="bi bi-arrow-right"></i></a>


                    </div>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- ========================================================= -->
<!-- End Course Information Section -->
<!-- ========================================================= -->